import React from 'react';

const MAX_ENERGY = 500;

function SidebarEnergy({ userEnergy }) {
  const percentage = Math.max(0, Math.min(100, Math.round((userEnergy / MAX_ENERGY) * 100)));

  return (
    <div className="mp-sidebar-energy">
      <p className="mp-sidebar-energy__title">Status de energia</p>
      <div className="mp-sidebar-energy__row">
        <strong>{userEnergy}</strong>
        <span>/ {MAX_ENERGY}</span>
      </div>
      <progress className="mp-sidebar-energy__bar" max="100" value={percentage} aria-label="nível de energia" />
    </div>
  );
}

export default SidebarEnergy;
